import { ButtonProps } from '@mui/material';

// The dashed outline the Figma drill-down gives every add control.
export const MATRIX_ADD_BUTTON: ButtonProps = { variant: 'outlined', sx: { borderStyle: 'dashed' } };
